import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { BLOKKENDOOS_SELECTORS } from '../../services/constants';
import contactEmailGenerator from '../../helpers/contactEmailGenerator';

const EmailNotUnique = () => {
  const { t } = useTranslation();
  const email = contactEmailGenerator();
  return (
    <div className='hidden' id={BLOKKENDOOS_SELECTORS.EMAIL_NOT_UNIQUE_CONTENT}>
      <h3>{t('not_unique_modal.title')}</h3>
      <p>{t('not_unique_modal.description')}</p>
      <p>
        <b>{t('not_unique_modal.question')}</b>
      </p>
      <p>
        <Trans i18nKey='fieldset_contact_card.text'>
          contentPlaceholder
          <a href='tel:+31206531544'>contentPlaceholder</a>
          contentPlaceholder
        </Trans>
        <a href={`mail:${email}`}>{email}</a>
      </p>
      <br />
    </div>
  );
};

export default EmailNotUnique;
